/* ==========================================================================
   Recipes on product pages

   Markup comes from snippets/kott-recipes.liquid. Each recipe's article body is
   printed into a <template>, which the browser parses but never renders: its
   <style> does not apply to the page, its <script> does not run, and its <img>
   never issues a request. That matters here — the recipe articles in this shop
   end with a promo box carrying an inline <style> that repaints the global .btn
   rule red, so injecting their HTML into the live DOM would break buttons
   store-wide. Nothing from an article reaches the page until it has been
   through clean() and normalise() below.

   normalise() rebuilds the article as plain text in our own elements. Articles
   are hand-authored in the blog editor and are wildly inconsistent — stray
   <meta charset> tags, <span> soup, inline styles, headings that say מצרכים on
   one recipe and מרכיבים on the next — so nothing of the original markup is
   trusted or carried over.

   Debug: add ?kottdebug=1 to a product URL to log which video matched which
   recipe. Use it to catch the wrong video being picked in the Files library,
   which otherwise fails silently as a missing link.
   ========================================================================== */
(function () {
  'use strict';

  /* One modal per product-template render. A product page has exactly one, but
     sections/featured-product.liquid renders the same template, so a page could
     hold two. Everything below is scoped by data-kott-product so a link can only
     ever open the modal belonging to its own product. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-kott-recipes]'), init);

  function init(root) {
  var product = root.dataset.kottProduct;
  var isMain = root.dataset.kottMain === 'true';
  var scope = '[data-kott-product="' + product + '"]';

  var container = root.querySelector('[data-kott-container]');
  var heading = root.querySelector('[data-kott-heading]');
  var body = root.querySelector('[data-kott-body]');
  var tabsEl = root.querySelector('[data-kott-tabs]');
  var shareBtn = root.querySelector('[data-kott-share]');
  var watchBtn = root.querySelector('[data-kott-watch]');
  var cartBtn = root.querySelector('[data-kott-atc]');
  var links = document.querySelectorAll('[data-kott-recipe-link]' + scope);

  /* Link DOM order is the video-card order, so tabs read in the same sequence
     as the videos on the page. Each entry also remembers its own card, which is
     how the watch button knows which video to open. */
  var order = Array.prototype.map.call(links, function (link) {
    var cell = link.closest('.kott-recipe-cell');
    return {
      handle: link.dataset.kottRecipeLink,
      label: link.dataset.kottLabel || link.textContent.replace(/\s*[←→]\s*$/, '').trim(),
      trigger: cell ? cell.querySelector('.product-video-grid__trigger') : null
    };
  });

  var recipes = {};
  var current = null;
  var lastFocus = null;
  var closeTimer = null;

  /* The snippet prints the modal next to the video grid, which puts it inside
     .product-grid__content — and snippets/kott-mobile-sticky-gallery.liquid
     gives that column `position: relative; z-index: 1` on phones. That is a
     stacking context, so the modal's z-index is resolved against its siblings
     inside the column rather than against the page, and anything higher at body
     level paints over it — the Profy announcement bar (sticky, z-index 100) sits
     right on top of the close button. Reparenting to <body> puts the modal in
     the root stacking context and also takes it out of reach of any ancestor
     overflow or transform. */
  document.body.appendChild(root);

  Array.prototype.forEach.call(
    document.querySelectorAll('template[data-kott-recipe]' + scope),
    function (tpl) {
      recipes[tpl.dataset.kottRecipe] = {
        handle: tpl.dataset.kottRecipe,
        title: tpl.dataset.kottTitle || '',
        articleUrl: tpl.dataset.kottUrl || '',
        template: tpl
      };
    }
  );

  /* ------------------------------------------------------------------------
     Cleaning
     ---------------------------------------------------------------------- */

  var DROP_TAGS = 'style,script,noscript,meta,link,img,picture,source,video,iframe,svg,form,input,button';

  function clean(frag) {
    /* A <br> carries a word boundary that textContent would otherwise swallow:
       "…שתומך<br>בהתחדשות…" reads as one run-on word. Swap each one for a space
       before anything reads the text. */
    Array.prototype.forEach.call(frag.querySelectorAll('br'), function (el) {
      el.parentNode.replaceChild(document.createTextNode(' '), el);
    });

    Array.prototype.forEach.call(frag.querySelectorAll(DROP_TAGS), function (el) {
      el.parentNode.removeChild(el);
    });

    /* The product promo box every recipe article ends with: a bordered div
       holding a product link. Redundant inside a product page, and it is what
       carries the .btn markup. Matched on the link rather than the border alone
       so a merely decorated paragraph is not swept up with it. */
    Array.prototype.forEach.call(frag.querySelectorAll('div[style]'), function (el) {
      if (el.querySelector('a[href*="/products/"]')) el.parentNode.removeChild(el);
    });

    Array.prototype.forEach.call(frag.querySelectorAll('[style],[class],[id]'), function (el) {
      el.removeAttribute('style');
      el.removeAttribute('class');
      el.removeAttribute('id');
    });

    return frag;
  }

  /* ------------------------------------------------------------------------
     Normalising

     Walks the cleaned fragment in document order and re-emits headings,
     paragraphs and lists as our own elements. Wrapper divs and spans are walked
     through rather than copied. Text is taken as textContent, so no markup from
     the article can reach the page.
     ---------------------------------------------------------------------- */

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }

  function text(node) {
    return (node.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function normalise(frag) {
    var out = document.createDocumentFragment();

    function walk(node) {
      Array.prototype.forEach.call(node.childNodes, function (child) {
        if (child.nodeType === 3) {
          var loose = text(child);
          if (loose) out.appendChild(el('p', 'kott-recipes__p', loose));
          return;
        }
        if (child.nodeType !== 1) return;

        var tag = child.tagName.toLowerCase();

        if (/^h[1-6]$/.test(tag)) {
          var title = text(child);
          if (title) out.appendChild(el('h3', 'kott-recipes__section-title', title));
        } else if (tag === 'p') {
          var para = text(child);
          if (para) out.appendChild(el('p', 'kott-recipes__p', para));
        } else if (tag === 'ul' || tag === 'ol') {
          var list = el(tag, 'kott-recipes__list');
          Array.prototype.forEach.call(child.children, function (li) {
            if (li.tagName.toLowerCase() !== 'li') return;
            var item = text(li);
            if (item) list.appendChild(el('li', '', item));
          });
          if (list.children.length) out.appendChild(list);
        } else if (tag !== 'br') {
          walk(child);
        }
      });
    }

    walk(frag);
    return out;
  }

  function render(recipe) {
    var frag = recipe.template.content.cloneNode(true);
    body.innerHTML = '';
    body.appendChild(normalise(clean(frag)));
  }

  /* ------------------------------------------------------------------------
     Open / close
     ---------------------------------------------------------------------- */

  /* Rebuilt on each open so the active pill is right; the strip itself is
     static per product, so a product with one recipe never shows it. */
  function renderTabs(activeHandle) {
    if (order.length < 2) {
      tabsEl.hidden = true;
      return;
    }
    tabsEl.hidden = false;
    tabsEl.innerHTML = '';
    order.forEach(function (entry) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'kott-recipes__tab' + (entry.handle === activeHandle ? ' is-active' : '');
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', entry.handle === activeHandle ? 'true' : 'false');
      tab.textContent = entry.label;
      tab.addEventListener('click', function () {
        if (entry.handle !== activeHandle) open(entry.handle);
      });
      tabsEl.appendChild(tab);
    });
  }

  /* Must run only once the modal is actually displayed. renderTabs() is called
     while the modal is still display:none, where the strip has no layout and
     any scrolling is silently discarded — which left the active pill hanging
     off the edge whenever the pills overflowed.

     Scrolls by a measured delta rather than scrollIntoView: it keeps the scroll
     inside the strip (scrollIntoView also scrolls ancestors, including the
     page), and a relative delta is immune to the RTL scrollLeft sign
     differences between browsers. */
  function centreActiveTab() {
    if (tabsEl.hidden) return;

    var scrollable = tabsEl.scrollWidth > tabsEl.clientWidth;
    tabsEl.classList.toggle('is-scrollable', scrollable);
    if (!scrollable) return;

    var active = tabsEl.querySelector('.is-active');
    if (!active) return;

    var strip = tabsEl.getBoundingClientRect();
    var pill = active.getBoundingClientRect();
    tabsEl.scrollLeft += (pill.left + pill.width / 2) - (strip.left + strip.width / 2);
  }

  function entryFor(handle) {
    for (var i = 0; i < order.length; i++) {
      if (order[i].handle === handle) return order[i];
    }
    return null;
  }

  function open(handle, focusReturn) {
    var recipe = recipes[handle];
    if (!recipe) return;

    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }

    current = recipe;
    lastFocus = focusReturn || null;

    heading.textContent = recipe.title;
    render(recipe);
    renderTabs(handle);
    if (watchBtn) watchBtn.hidden = !(entryFor(handle) && entryFor(handle).trigger);

    root.classList.add('is-visible');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    root.querySelector('[data-kott-content]').scrollTop = 0;
    /* After is-visible, so the strip has layout to scroll. */
    centreActiveTab();

    requestAnimationFrame(function () {
      root.classList.add('is-open');
      var close = root.querySelector('[data-kott-close-btn]');
      if (close) close.focus();
    });
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    closeTimer = setTimeout(function () {
      root.classList.remove('is-visible');
      closeTimer = null;
    }, 250);

    if (lastFocus) {
      lastFocus.focus();
      lastFocus = null;
    }
  }

  Array.prototype.forEach.call(links, function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      open(link.dataset.kottRecipeLink, link);
    });
  });

  /* closest(), not a direct attribute test on event.target: the close button
     holds an <svg>, so a real click lands on the icon or its <path> and never on
     the button that carries the attribute. */
  root.addEventListener('click', function (event) {
    var target = event.target;
    if (target && target.closest && target.closest('[data-kott-close]')) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* Keeps focus inside the dialog while it is open. */
  container.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    var focusable = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  /* ------------------------------------------------------------------------
     Share

     Percent-decoded so a Hebrew URL reads as Hebrew in the message instead of
     as a wall of %D7 escapes — it roughly halves the message length. No emoji:
     they survive wa.me inconsistently across desktop clients.
     ---------------------------------------------------------------------- */

  function decode(url) {
    try {
      return decodeURIComponent(url);
    } catch (e) {
      return url;
    }
  }

  function deepLink(handle) {
    return window.location.origin + decode(window.location.pathname) + '?recipe=' + handle;
  }

  /* article.url is root-relative; WhatsApp needs it absolute to linkify. */
  function absolute(url) {
    return url.charAt(0) === '/' ? window.location.origin + url : url;
  }

  function truncate(value, max) {
    var clean = (value || '').replace(/\s+/g, ' ').trim();
    if (clean.length <= max) return clean;
    var cut = clean.slice(0, max);
    var lastSpace = cut.lastIndexOf(' ');
    return (lastSpace > max * 0.6 ? cut.slice(0, lastSpace) : cut) + '…';
  }

  /* Built from the recipe already rendered in the modal rather than from a
     field someone has to fill in: the intro paragraph, then the first section
     with a list — which is the ingredients on every one of these articles — and
     only then the links. A recipient sees what the recipe actually is before
     deciding whether to open anything. Capped so the message stays readable in
     a chat bubble; the full recipe is one tap away. */
  /* Not every article opens with a paragraph. Some (רול אפס) start with a
     heading that acts as a subtitle, so fall back to that rather than sending a
     message with no description at all. */
  function introText() {
    var para = body.querySelector('.kott-recipes__p');
    if (para) return truncate(para.textContent, 260);

    var first = body.firstElementChild;
    var next = first && first.nextElementSibling;
    if (first && first.classList.contains('kott-recipes__section-title') &&
        (!next || !isList(next))) {
      return truncate(first.textContent, 260);
    }
    return '';
  }

  function isList(node) {
    return node.tagName === 'UL' || node.tagName === 'OL';
  }

  /* The first heading is not reliably the ingredients one — articles that group
     their ingredients (רול אפס, סניקרס) lead with a subtitle heading, or with a
     heading whose own content sits under sub-headings. Take the first heading
     that actually has a list under it. */
  function firstListSection() {
    var headings = body.querySelectorAll('.kott-recipes__section-title');
    for (var i = 0; i < headings.length; i++) {
      var next = headings[i].nextElementSibling;
      if (next && isList(next)) return { heading: headings[i], list: next };
    }
    return null;
  }

  function shareText(recipe) {
    var lines = ['*' + recipe.title + '*', ''];

    var intro = introText();
    if (intro) lines.push(intro, '');

    var section = firstListSection();
    if (section) {
      lines.push('*' + truncate(section.heading.textContent, 60) + '*');
      var items = Array.prototype.slice.call(section.list.children, 0, 12);
      items.forEach(function (li) {
        var item = truncate(li.textContent, 90);
        if (item) lines.push('• ' + item);
      });
      if (section.list.children.length > items.length) lines.push('…');
      lines.push('');
    }

    if (recipe.articleUrl) {
      lines.push(root.dataset.kottStrFull, decode(absolute(recipe.articleUrl)), '');
    }
    lines.push(root.dataset.kottStrBuy, deepLink(recipe.handle));

    return lines.join('\n');
  }

  if (shareBtn) {
    shareBtn.addEventListener('click', function () {
      if (!current) return;
      window.open('https://wa.me/?text=' + encodeURIComponent(shareText(current)), '_blank');
    });
  }

  /* ------------------------------------------------------------------------
     "Show me" — hand off to the theme's video modal

     The two modals cannot be on screen together: .product-video-modal lives
     inside .product-grid__content (z-index 1) within .transition-body
     (z-index 2), so its z-index 9999 is resolved inside that context and it
     paints *under* this modal, which sits at <body> on 10000. Raising its
     z-index cannot fix that — the ancestor is the ceiling. So this closes the
     recipe first and the video modal offers a way back.

     The video grid's script is a closed IIFE with no public API, so the video
     is opened by clicking the card's own trigger. Nothing in that snippet
     changes, and it keeps working untouched on products with no recipes.
     ---------------------------------------------------------------------- */

  var videoModal = document.querySelector('.product-video-modal');
  var backBtn = null;
  var videoToRecipe = {};
  order.forEach(function (entry) {
    if (entry.trigger) videoToRecipe[entry.trigger.getAttribute('data-video-id')] = entry.handle;
  });

  if (watchBtn) {
    watchBtn.addEventListener('click', function () {
      if (!current) return;
      var entry = entryFor(current.handle);
      if (!entry || !entry.trigger) return;
      close();
      entry.trigger.click();
    });
  }

  /* Their openModal hides every media element and shows only the chosen one. */
  function shownVideoId() {
    var all = videoModal.querySelectorAll('.product-video-modal__media');
    for (var i = 0; i < all.length; i++) {
      if (all[i].style.display && all[i].style.display !== 'none') {
        return all[i].getAttribute('data-video-id');
      }
    }
    return null;
  }

  function syncBackButton() {
    if (!videoModal) return;
    if (!videoModal.classList.contains('is-active')) {
      if (backBtn) backBtn.hidden = true;
      return;
    }
    var handle = videoToRecipe[shownVideoId()];
    if (!handle) {
      if (backBtn) backBtn.hidden = true;
      return;
    }
    if (!backBtn) {
      backBtn = document.createElement('button');
      backBtn.type = 'button';
      backBtn.className = 'kott-recipe-video-back';
      backBtn.textContent = root.dataset.kottStrBack;
      backBtn.addEventListener('click', function () {
        var target = backBtn.dataset.handle;
        var closeVideo = videoModal.querySelector('.product-video-modal__close');
        if (closeVideo) closeVideo.click();
        if (target) setTimeout(function () { open(target); }, 80);
      });
      (videoModal.querySelector('.product-video-modal__content') || videoModal).appendChild(backBtn);
    }
    backBtn.dataset.handle = handle;
    backBtn.hidden = false;
  }

  /* Their openModal adds .is-active before it sets display on the chosen media,
     so read one tick later. Only the product page's own modal is wired, so a
     featured-product section cannot attach a second observer to it. */
  if (videoModal && isMain && window.MutationObserver) {
    new MutationObserver(function () {
      setTimeout(syncBackButton, 60);
    }).observe(videoModal, { attributes: true, attributeFilter: ['class'] });
  }

  /* ------------------------------------------------------------------------
     Add to cart

     Reads the variant the shopper actually has selected. theme.js keeps
     [data-product-select] in sync as variants change (theme.js:8855), so this
     stays correct on multi-variant products instead of pinning one id the way
     the Visually test does.

     One ajaxProduct:added event is enough — theme.js:4823 listens for it and
     opens the drawer itself.
     ---------------------------------------------------------------------- */

  function selectedVariantId() {
    var select = document.querySelector('.shopify-section--main-product [data-product-select]');
    if (select && select.value) return select.value;
    var input = document.querySelector('.shopify-section--main-product form.product-single__form [name="id"]');
    if (input && input.value) return input.value;
    return root.dataset.kottVariant || '';
  }

  if (cartBtn) {
    cartBtn.addEventListener('click', function () {
      var variantId = selectedVariantId();
      if (!variantId) return;

      var original = cartBtn.textContent;
      cartBtn.disabled = true;
      cartBtn.textContent = root.dataset.kottStrAdding;

      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('cart/add failed: ' + response.status);
          return response.json();
        })
        .then(function (data) {
          cartBtn.textContent = root.dataset.kottStrAdded;
          document.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: data, addToCartBtn: null }
            })
          );
          setTimeout(function () {
            cartBtn.textContent = original;
            cartBtn.disabled = false;
            close();
          }, 600);
        })
        .catch(function (error) {
          console.error('[kott-recipes]', error);
          cartBtn.textContent = root.dataset.kottStrError;
          setTimeout(function () {
            cartBtn.textContent = original;
            cartBtn.disabled = false;
          }, 2000);
        });
    });
  }

  /* ------------------------------------------------------------------------
     Deep link and debug
     ---------------------------------------------------------------------- */

  var params = new URLSearchParams(window.location.search);

  /* Only the product page's own modal answers ?recipe= — a featured-product
     section for a different product must not hijack the deep link. */
  var wanted = params.get('recipe');
  if (isMain && wanted && recipes[wanted]) open(wanted);

  if (params.get('kottdebug') === '1') {
    var cards = document.querySelectorAll('.product-video-grid__item');
    console.log('[kott-recipes] recipes on this product:', Object.keys(recipes));
    console.table(
      Array.prototype.map.call(cards, function (card, index) {
        var link = card.parentNode.querySelector('[data-kott-recipe-link]');
        var trigger = card.querySelector('[data-video-id]');
        return {
          card: index + 1,
          videoId: trigger ? trigger.getAttribute('data-video-id') : '',
          matched: link ? link.dataset.kottRecipeLink : '— none —',
          label: link ? link.textContent.trim() : ''
        };
      })
    );
  }
  }
})();
